export const USER_JWT_TOKEN_COOKIE_NAME = "jwt-token";
export const ADMIN_JWT_TOKEN_COOKIE_NAME = "admin-token";
export const COOKIE_MAX_AGE = 1637660;
